import { FormControlLabel, FormHelperText, FormLabel, Grid, InputLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CustomMessage from '@react-form-fields/core/components/CustomMessage';
import FieldHidden from '@react-form-fields/material-ui/components/Hidden';
import Alert from 'components/Alert';
import CharacterCounter from 'components/CharacterCounter';
import CropUploader from 'components/CropUploader';
import { removeDoubleSpace } from 'helpers/functions';
import { EChargeType } from 'interfaces/IEditProduct';
import { EPartnerCode } from 'interfaces/IProduct';
import React, { Component } from 'react';
import { FormContent } from 'scenes/Producer/Product/EditProduct/components/FormContent';
import styles from 'scenes/Producer/Product/NewProduct/components/Forms/styles';
import { EProductType } from 'v2/interfaces/product';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { run } from 'validations/ruleRunner';

import Validations from './validations';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  product: IProduct;
  handleChange: Function;
  categoryList: Array<any>;
  setRefField: any;
  setRefError: any;
  validateTitleForSave: any;
  productTitleExists: boolean;
  enabledValidation: boolean;
  categorySelected?: any;
  hasDeliveries?: boolean;
  resetDeliveries?: () => void;

  classes?: any;
  handleProductType?: Function;
}

interface IStates {
  showErrors: boolean;
  validationErrors: Array<any>;
}

class General extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: [],
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isInvalid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleProductTypeChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (this.props.hasDeliveries) {
      const confirm = await Alert.confirm({
        title: 'Atenção',
        message: 'Ao alterar o tipo de produto, você perderá todas as entregas cadastradas. Deseja continuar?',
      });

      if (confirm) {
        this.props.resetDeliveries();
      }
    }

    this.props.handleProductType('type', e.target.value);
  };

  componentDidUpdate(prevProps: IProps) {
    if (
      (prevProps.enabledValidation === false && this.props.enabledValidation) ||
      (this.props.enabledValidation && this.props.product !== prevProps.product)
    ) {
      let { product } = this.props;
      let newState = { ...this.state };
      newState.validationErrors = run(product, Validations);
      this.setState(newState);
    }
  }
  render() {
    const { handleChange, product, classes, categoryList, setRefField, setRefError, validateTitleForSave, productTitleExists } = this.props;
    const isService = product.cnt_partner_cod === EPartnerCode.SERVICE;
    const categories = Array.isArray(categoryList) ? categoryList : [];
    const isSubscription = product.charge_type === EChargeType.SUBSCRIPTION;
    const userHasAccessToSubscriptionModule = eduzzAccountsService.verifyUserHasBetaModule('planos_assinatura');

    function formTitle() {
      if (isSubscription) {
        return 'Dados básicos da assinatura';
      }

      if (isService) {
        return 'Dados básicos do serviço';
      }

      return 'Dados básicos do produto';
    }

    return (
      <FormContent title={formTitle()} loading={false}>
        <Grid container spacing={2} alignItems='center'>
          <Grid item xs={12}>
            {isSubscription && userHasAccessToSubscriptionModule && (
              <>
                <FormLabel>Você está criando um plano de assinatura para um produto ou serviço?</FormLabel>
                <RadioGroup row onChange={this.handleProductTypeChange}>
                  <FormControlLabel
                    value='product'
                    control={<Radio id='new-product-type-product-radio-button' />}
                    checked={product.type === EProductType.DIGITAL}
                    label='Produto'
                  />
                  <FormControlLabel
                    value='service'
                    control={<Radio id='new-product-type-service-radio-button' />}
                    checked={product.type === EProductType.SERVICE}
                    label='Serviço'
                  />
                </RadioGroup>
                {this.isInvalid('type') && <FormHelperText error>Selecione o tipo de produto</FormHelperText>}
              </>
            )}

            <TextField
              className={classes.input}
              label={isService ? 'Título do serviço *' : 'Título do produto *'}
              id='new-product-title'
              fullWidth
              error={this.isInvalid('title')}
              helperText={
                this.isInvalid('title')
                  ? this.errorFor('title')
                  : `O título do seu ${isService ? 'serviço' : 'produto'} deve ser condizente com o que vai ser entregue`
              }
              value={product.title}
              onBlur={(e: any) => validateTitleForSave(e.target.value)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('title', e.target.value)}
              InputProps={{
                disableUnderline: true,
                inputRef: (ref: HTMLInputElement) => setRefField('title', ref),
              }}
              InputLabelProps={{
                shrink: true,
              }}
              placeholder={'Ex: Certificação Especialista em Tráfego Pago'}
            />
            <FieldHidden name='título' ref={(ref: any) => setRefError('title', ref)} value={product.title} validation='required' />
            {productTitleExists && (
              <FieldHidden name='título não existente' ref={(ref: any) => setRefError('title', ref)} value={''} validation='required'>
                <CustomMessage rules='required'>Título já está sendo usado por outro produto</CustomMessage>
              </FieldHidden>
            )}

            <CharacterCounter
              value={product.description}
              limits={4000}
              minimum={100}
              id='new-product-description'
              error={this.isInvalid('description')}
              ref={(ref: any) => setRefField('description', ref)}
              helperText={
                this.isInvalid('description')
                  ? this.errorFor('description')
                  : 'A descrição do ' +
                    (isService ? 'serviço' : 'produto') +
                    ' deve deixar claro do que se trata seu ' +
                    (isService ? 'serviço' : 'produto')
              }
              label={isService ? 'Descrição do serviço *' : 'Descrição do produto *'}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('description', removeDoubleSpace(e.target.value))}
              singleSpace={true}
              placeholder={
                'Ex: Certificação Especialista em Tráfego Pago. Você irá aprender o método testado e aprovado por centenas de empresários para gerar novos clientes para o seu negócio todos os dias.'
              }
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel error={this.isInvalid('categories')}>Categorias *</InputLabel>
            <Select
              id='new-product-categories'
              error={this.isInvalid('categories') ? this.errorFor('categories') : null}
              value={product.getIdCategories()}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('categories', e.target.value)}
              placeholder='Informe uma ou mais categorias'
              renderValue={(selected: any[]) =>
                categories
                  .filter((c) => selected.includes(c.id))
                  .map((m) => m.name)
                  .join(', ')
              }
              multiple
              fullWidth
            >
              {categories.map((item: any) => (
                <MenuItem key={item.id} value={item.id}>
                  <Checkbox checked={product.getIdCategories().includes(item.id)} />
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText style={{ color: '#dc3f53' }}>{this.isInvalid('categories') ? this.errorFor('categories') : null}</FormHelperText>
          </Grid>
          <Grid item xs={12}>
            <InputLabel error={this.isInvalid('image_id')}>Imagem do {isService ? 'serviço' : 'produto'} *</InputLabel>

            <CropUploader
              id='new-product-image'
              name='image'
              fileName='image_id'
              uploadType='cnt_foto'
              onChange={handleChange}
              ref={(ref: any) => setRefField('image_id', ref)}
            />
            <FormHelperText style={{ color: this.errorFor('image_id') ? '#dc3f53' : '#0000008a' }}>
              {this.isInvalid('image_id')
                ? this.errorFor('image_id')
                : isService
                ? 'A imagem deve ter boa qualidade e representar o serviço que está sendo oferecido.'
                : 'A imagem deve ter boa qualidade e representar o que está sendo vendido.'}
            </FormHelperText>
          </Grid>
        </Grid>
      </FormContent>
    );
  }
}

export default styles(General);
